import { render, staticRenderFns } from "./SelectFacet.vue?vue&type=template&id=db0a2fbe&"
import script from "./SelectFacet.vue?vue&type=script&lang=js&"
export * from "./SelectFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/www/finda/current/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0a2fbe')) {
      api.createRecord('db0a2fbe', component.options)
    } else {
      api.reload('db0a2fbe', component.options)
    }
    module.hot.accept("./SelectFacet.vue?vue&type=template&id=db0a2fbe&", function () {
      api.rerender('db0a2fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buysearchsell/vue/components/refinements/SelectFacet.vue"
export default component.exports